import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  const path = location.pathname;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  const handleLogout = () => {
    logout();
    setDropdownOpen(false);
    navigate('/login');
  };
  
  return (
    <header className="app-header">
      <div className="container">
        <div className="app-title">
          <img src="/images/logo.png" alt="Logo" className="logo-image" />
        </div>
        <div className="app-nav">
          <Link to="/home" className={path.includes('/home') || path === '/' ? 'active-nav' : ''}>
            Home
          </Link>
          <Link to="/events" className={path.includes('/events') ? 'active-nav' : ''}>
            Events
          </Link>
          <Link to="/rsvp" className={path.includes('/rsvp') ? 'active-nav' : ''}>
            RSVP
          </Link>
          <Link to="/templates" className={path.includes('/templates') ? 'active-nav' : ''}>
            Templates
          </Link>
        </div>
        <div className="user-info">
          {currentUser ? (
            <div className="user-dropdown" ref={dropdownRef}>
              <div 
                className="user-name-display" 
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <span className="user-name">{currentUser.fullName || currentUser.username || currentUser.email}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}>
                  <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              {dropdownOpen && (
                <div className="user-dropdown-content">
                  <Link to="/profile" className="dropdown-item" onClick={() => setDropdownOpen(false)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="currentColor"/>
                    </svg>
                    My Profile
                  </Link>
                  <div className="dropdown-divider"></div>
                  <button onClick={handleLogout} className="logout-btn dropdown-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17 7L15.59 8.41L18.17 11H8V13H18.17L15.59 15.58L17 17L22 12L17 7ZM4 5H12V3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H12V19H4V5Z" fill="currentColor"/>
                    </svg>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <Link to="/login" className="login-link">Sign In</Link>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header; 